import { grayColor } from "vendor/colors"

export const Empty = ({ message }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", color: grayColor[3] }}>
      {message}
    </div>
  )
}
